import React from "react";
import "./Checkbox.scss";

interface ICheckboxProps {
  checked: boolean; // true if checkbox is checked, else false
  id?: string;
  name: string; // name for input checkbox
  disabled?: boolean; // if disabled then pass true
  required?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
  children?: React.ReactNode
  legend?: string;
  ariaLabel?: string;
}

interface IMultiSelectCheckBoxProps {
  list: Array<{
    OptionDescription: string;
    QuestionID: number;
    OptionId: number;
    checked: boolean;
    disabled?: boolean;
  }>;
  disabled?: boolean; // if disabled then pass true
  onChange: (
    list: Array<{
      OptionDescription: string;
      QuestionID: number;
      OptionId: number;
      checked: boolean;
      disabled?: boolean;
    }>
  ) => void; // function to be called on change
  legend?: string;
}

const Checkbox: React.FC<ICheckboxProps> = (props) => {
  return (
    <label className={"checkbox" + (props.disabled ? " disabled" : "")} htmlFor={props.id}>
      <input
        type="checkbox"
        id={props.id}
        onChange={props.onChange}
        checked={props.checked || false}
        name={props.name}
        required={props.required || undefined}
        aria-required={props.required ? true : undefined}
        aria-label={props.children ? undefined : props.ariaLabel}
      />
      <span className="checked edel-icon-tick" aria-hidden="true"></span>
      {props.children && (
        <span className="checkbox_label">{props.children}</span>
      )}
    </label>
  );
};

export const MultiSelectCheckBox: React.FC<IMultiSelectCheckBoxProps> = (
  props
) => {
  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    let updatedList: typeof props.list = props.list.map((checkbox) => {
      if (checkbox.OptionDescription === event.target.name) {
        return {
          OptionDescription: checkbox.OptionDescription,
          QuestionID: checkbox.QuestionID,
          OptionId: checkbox.OptionId,
          checked: event.target.checked,
        };
      }
      return checkbox;
    });
    props.onChange(updatedList);
  }

  return (
    <fieldset className="multiSelectFieldset">
      {props.legend && <legend className="sr-only">{props.legend}</legend>}
      {!props.legend && <legend className="sr-only">Select options</legend>}
      {props.list.map((checkbox) => (
        <label
          key={checkbox.OptionDescription}
          className={
            "checkbox multiSelect" +
            (props.disabled || checkbox.disabled ? " disabled" : "")
          }
        >
          <input
            type="checkbox"
            onChange={onChange}
            checked={checkbox.checked || false}
            name={checkbox.OptionDescription}
            disabled={props.disabled || checkbox.disabled}
          />
          <span className="checked edel-icon-tick" aria-hidden="true"></span>
          {checkbox.OptionDescription && (
            <span className="checkbox_label">{checkbox.OptionDescription}</span>
          )}
        </label>
      ))}
    </fieldset>
  );
};

export default Checkbox;
